<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The Author’s experience was primarily technical. Obviously, Mathematics was absolutely necessary. He was influenced by Pythagoras who insisted that 1+2+3+4=10, is the perfect number. This is the base of our money and measurement system. Pythagoras is well known by his theorem. In a right angled triangle, the square of the hypotenuse is equal to the sum of the squares of the other two sides. Although Pythagoras discovered this theorem it existed long before Pythagoras was born. It is this a priori – assumptions about human nature; it has made progress in distinguishing the difference between man and beast. Metaphysics and ethics cannot be neglected.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?02dee1e4